import React, { PureComponent } from "react";
import SvgIcon from "material-ui/SvgIcon";

class List extends PureComponent {
    render() {
        return (
            <SvgIcon {...this.props}>
                <path
                    d="M17,22H5c-0.5,0-1-0.4-1-1V5c0-0.5-0.4-1-1-1h0C2.4,4,2,4.4,2,5v17v1c0,0.5,0.4,1,1,1h1h13c0.5,0,1-0.4,1-1v0
                    C18,22.4,17.6,22,17,22z"
                />
                <path
                    d="M21,0H7C6.4,0,6,0.4,6,1v18c0,0.6,0.4,1,1,1h14c0.6,0,1-0.4,1-1V1C22,0.4,21.6,0,21,0z M10,16c0,0.5-0.4,1-1,1h0
                    c-0.5,0-1-0.4-1-1v0c0-0.5,0.4-1,1-1h0C9.6,15,10,15.4,10,16L10,16z M10,12c0,0.5-0.4,1-1,1h0c-0.5,0-1-0.4-1-1v0c0-0.5,0.4-1,1-1
                    h0C9.6,11,10,11.4,10,12L10,12z M10,8c0,0.5-0.4,1-1,1h0C8.4,9,8,8.6,8,8v0c0-0.5,0.4-1,1-1h0C9.6,7,10,7.4,10,8L10,8z M10,4
                    c0,0.5-0.4,1-1,1h0C8.4,5,8,4.6,8,4v0c0-0.5,0.4-1,1-1h0C9.6,3,10,3.4,10,4L10,4z M20,16c0,0.5-0.4,1-1,1h-6c-0.5,0-1-0.4-1-1v0
                    c0-0.5,0.4-1,1-1h6C19.6,15,20,15.4,20,16L20,16z M20,12c0,0.5-0.4,1-1,1h-6c-0.5,0-1-0.4-1-1v0c0-0.5,0.4-1,1-1h6
                    C19.6,11,20,11.4,20,12L20,12z M20,8c0,0.5-0.4,1-1,1h-6c-0.5,0-1-0.4-1-1v0c0-0.5,0.4-1,1-1h6C19.6,7,20,7.4,20,8L20,8z M20,4
                    c0,0.5-0.4,1-1,1h-6c-0.5,0-1-0.4-1-1v0c0-0.5,0.4-1,1-1h6C19.6,3,20,3.4,20,4L20,4z"
                />
            </SvgIcon>
        );
    }
}

export default List;
